import React from "react";

import {Modal, Form, Row, Col, Input} from "antd";

export default class CancelOrderModal extends React.Component {
    state = {
        order: this.props.order || {},
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.order != null) {
            this.setState({
                order: nextProps.order
            })
        }
    }

    render() {
        return (
            <Modal title={"Cancel Order"} visible={this.props.visible}
                   onOk={e => this.props.onOk(this.state.order)}
                   onCancel={this.props.onCancel}>
                <div>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Cancellation Reason" required="true">
                                <Input
                                    value={this.state.order.remarks}
                                    onChange={event =>
                                        this.setState({
                                            order: {...this.state.order, remarks: event.target.value}
                                        })}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </div>

            </Modal>)
    }
}